import ChooseCategory from "../components/CreateAuctionListingForm/ChooseCategory";
import Container from "../components/layout/Container";
import OtherBuylistingCustomForm from "../components/OthersCustomFiledForm/OtherBuylistingCustomForm";
import FilterHeader from "../components/Shared/FilterHeader/FilterHeader";
import MyAccount from "../components/Shared/MyAccount/MyAccount";

const OthersBuylistingCustomForm = () => {
  return (
    <Container>
      <div className="flex items-start justify-between gap-x-6">
        <MyAccount />
        <div className="grow">
          <FilterHeader
            title={"CREATING BUY NOW LIST"}
            dropdown={false}
            className="mt-[60px]"
          />
          <ChooseCategory />
          <OtherBuylistingCustomForm />
        </div>
      </div>
    </Container>
  );
};

export default OthersBuylistingCustomForm;
